// extracted by mini-css-extract-plugin
export default {"ecospendPayeeBlock":"lVqJOMdlUARGUFhT4FgQ","block":"Xw1yDGOzQo_dNT4q4rrQ"};